function Currency(value) {
    return "$" + value.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits : 2, minimumFractionDigits : 2 });
}

export default Currency